import ReactModal from 'react-modal'
import classes from './Modal.module.scss'
import * as cookies from 'browser-cookies'
import { COOKIE_NAME } from '../../constants'
import type { ReactNode } from 'react'
import type { Theme } from '../types'

type from = 'left' | 'right' | 'bottom'

// Transition and position styling to apply to the modal when it is opened/closed
const classStyles: Record<from, ReactModal.Classes> = {
  left: {
    base: classes.ModalContentFromLeft,
    afterOpen: classes.ModalContentFromLeftAfterOpen,
    beforeClose: classes.ModalContentFromLeftBeforeClose
  },
  right: {
    base: classes.ModalContentFromRight,
    afterOpen: classes.ModalContentFromRightAfterOpen,
    beforeClose: classes.ModalContentFromRightBeforeClose
  },
  bottom: {
    base: classes.ModalContentFromBottom,
    afterOpen: classes.ModalContentFromBottomAfterOpen,
    beforeClose: classes.ModalContentFromBottomBeforeClose
  }
}

const getTheme = () => {
  const cookiesTheme = cookies.get(COOKIE_NAME)

  return (
    !cookiesTheme
      ? 'eggplant'
      : cookiesTheme
  ) as Theme
}

// css rgba function cannot accept theme variable, so need manually make the switch of the overlay theme background-color
// Styles to apply to the overlay when it is opened/closed
const overlayStyles = getTheme() === 'eggplantDark'
  ? {
    base: classes.ModalOverlay,
    afterOpen: classes.ModalOverlayAfterOpenDark,
    beforeClose: classes.ModalOverlayBeforeClose
  }
  : {
    base: classes.ModalOverlay,
    afterOpen: classes.ModalOverlayAfterOpenLight,
    beforeClose: classes.ModalOverlayBeforeClose
  }

export interface Props {
  children: ReactNode
  closeTimeoutMS?: number
  isOpen: boolean
  from?: from
  label: string
  onRequestClose: () => void
  shouldCloseOnOverlayClick?: boolean
}

const Modal = ({
  children,
  closeTimeoutMS = 500,
  isOpen = false,
  from = 'right',
  label,
  onRequestClose,
  shouldCloseOnOverlayClick = true
}: Props) =>
  <ReactModal
    ariaHideApp={false} // this should be revisited if Modals always use the same title element
    className={classStyles[from]}
    closeTimeoutMS={closeTimeoutMS} // allow for exit animation
    contentLabel={label}
    isOpen={isOpen}
    onRequestClose={
      isOpen
        ? onRequestClose
        : () => {}
    }
    overlayClassName={overlayStyles}
    shouldCloseOnEsc
    shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    style={
      {
        content: {
          transition: `transform ${closeTimeoutMS / 1000}s`
        }
      }
    }
  >
    {children}
  </ReactModal>

export default Modal
